import cn from 'classnames';
import LinkHref from 'components/LinkHref';
import Wrapper from 'components/Wrapper';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import SnLogo from 'svgs/logos/logo-sn-h.svg';
import { snApiUrl } from 'utils/config';
import HoverMenuButton from './HoverMenuButton.js';
import { activeLink, fixedC, link, links, logo, navSpace, notificationIsShownC, root, space, wrapper } from './ProductNav.module.scss';

const ProductNav = ({ isFixed, notificationIsShown }) => {
  const navList = {
    links: [
      {
        link: '/surenotify',
        text: '首頁',
        openNew: false,
        hasDropdown: false,
      },
      {
        link: snApiUrl,
        text: 'API Doc',
        openNew: true,
        hasDropdown: false,
      },
    ],
  };
  const Logo = SnLogo;
  
  return (
    <div>
      <div className={cn({ [navSpace]: isFixed })}></div>
      <div
        className={cn(root, {
          [fixedC]: isFixed,
          [notificationIsShownC]: notificationIsShown,
        })}
      >
        <Wrapper size="L" className={wrapper}>
          <h3 className="hide">Surenotify</h3>
          <Link to={navList.links[0].link}><Logo className={logo} /></Link>
          <div className={links}>
            { navList.links.map((value, i) => (
              value.hasDropdown ? 
              (
                <div key={i}>
                  <HoverMenuButton
                    dropdownData={value.dropdownData}
                    text={value.text}
                    link={value.link}
                    notificationIsShown={notificationIsShown}
                  />
                </div>
              )
              :
              (
                <div key={i+200}>
                  <LinkHref
                    className={link}
                    activeClassName={activeLink}
                    link={value.link}
                    text={value.text}
                    openNew={value.openNew}
                  />
                </div>
              )
            ))}
          </div>
          <div className={space}></div>
        </Wrapper>
      </div>
    </div>
  );
};

ProductNav.propTypes = {
  isFixed: PropTypes.bool.isRequired,
  notificationIsShown: PropTypes.bool,
};
ProductNav.defaultTypes = {
  isFixed: false,
  notificationIsShown: false,
};

export default ProductNav;
